<div class="container-fluid test-planning">
  <div class="agent-body">
    <div class="button-list d-none">
      <button class="agent-btn add-btn" (click)="addOrRemoveTestPlan('+')">
        <mat-icon>format_list_bulleted_add</mat-icon>
        <!-- icons need to be changed -->
        Add New Test Plan
      </button>
      <button class="agent-btn remove-btn" (click)="addOrRemoveTestPlan('-')">
        <mat-icon>playlist_remove</mat-icon>
        Remove Test Plan
      </button>
    </div>
    <div class="d-flex justify-content-end my-2">
      <button class="btn-accello-secondary btn-accello mx-2" (click)="addOrRemoveTestPlan('+')">
        <img src="assets/images/virtusa-icons/add-icon-dark.svg" alt="Add Icon" width="18" height="18" />
        Add New Test Plan
      </button>
      <button class="btn-accello-ternary btn-accello" (click)="addOrRemoveTestPlan('-')">
        <img src="assets/images/virtusa-icons/remove-icon-dark.svg" alt="Remove Icon" width="18" height="18" />
        Remove Test Plan
      </button>
    </div>
    <div *ngIf="isDataLoaded" class="table-div">
      <app-zorro-table tableId="test-planning" class="w-100" [columns]="columns" [data]="dataSource"
        (handleActions)="handleActionsInTable($event)" (onRowSelect)="handleSelect($event)"></app-zorro-table>
    </div>
    <div *ngIf="!isDataLoaded" class="load-wrap v-center">
      <app-loading [text]="'Loading data'"></app-loading>
    </div>
  </div>